import React, { forwardRef, useState } from 'react';
import { cn } from '@/utils';
import Eye from '@/svgs/eye.svg?react';
import EyeClosed from '@/svgs/eye-closed.svg?react';

export const inputClassNames =
  'block w-full rounded border border-brand-25 focus:border-brand focus:dark:border-brand-dark focus:ring-brand/20 focus:dark:ring-brand-dark/20 dark:border-brand-dark-20 text-base bg-transparent text-base focus:ring-4  dark:text-brand-light-75 placeholder:text-brand-dark-100/40 placeholder:dark:text-brand-light-25';

const TextInput = forwardRef<
  HTMLInputElement,
  React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  >
>((props, ref) => {
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const togglePasswordVisibility = () => {
    setShowPassword(prevState => !prevState);
  };
  return (
    <div className="relative">
      <input
        {...props}
        ref={ref}
        type={showPassword && props.type === 'password' ? 'text' : props.type}
        className={cn(inputClassNames, props.className)}
      />
      {props.type === 'password' && (
        <button
          type="button"
          className="absolute right-2 top-1/2 -translate-y-1/2 transform"
          onClick={togglePasswordVisibility}
        >
          {showPassword && props.type === 'password' ? (
            <EyeClosed className="text-brand-light-25" />
          ) : (
            <Eye className="h-5 w-5 text-brand-light-25" />
          )}
        </button>
      )}
    </div>
  );
});

export default TextInput;
